import { render, staticRenderFns } from "./ChangeLabelsModal.vue?vue&type=template&id=6944a4f8&scoped=true&lang=pug"
import script from "./ChangeLabelsModal.vue?vue&type=script&lang=ts"
export * from "./ChangeLabelsModal.vue?vue&type=script&lang=ts"
import style0 from "./ChangeLabelsModal.vue?vue&type=style&index=0&id=6944a4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6944a4f8",
  null
  
)

export default component.exports